<div class="h-100 w-100 d-flex flex-column position-relative p-0 m-0">
    <div
        *ngIf="loading; else content"
        class="h-100 w-100 d-flex align-items-center justify-content-center"
    >
        <app-loader-default></app-loader-default>
    </div>

    <ng-template #content>
        <div
            class="d-flex justify-content-center gap-2 repartitionTabs flex-shrink-0"
            *ngIf="groupsCountingEnabled"
        >
            <button
                type="button"
                class="repartitionTab d-flex align-items-center gap-1"
                [class.active]="entryTab === 'visits'"
                (click)="setEntryTab('visits')"
            >
                <img
                    src="/assets/svg/repartition.svg"
                    height="14px"
                    class="repartitionTab-icon"
                />
                <span>{{ 'visitorsTabs' | translate }}</span>
            </button>
            <button
                type="button"
                class="repartitionTab d-flex align-items-center gap-1"
                [class.active]="entryTab === 'groups'"
                (click)="setEntryTab('groups')"
            >
                <img
                    src="/assets/svg/repartition-group.svg"
                    height="14px"
                    class="repartitionTab-icon"
                />
                <span>{{ 'groupsTabs' | translate }}</span>
            </button>
        </div>

        <div
            class="flex-grow-1 overflow-hidden d-flex flex-column position-relative w-100"
            *ngIf="!emptyState; else emptyStateTemplate"
        >
            <div
                class="entry-legend d-flex flex-wrap justify-content-center gap-3 pt-2 pb-1"
            >
                <div
                    class="entry-legend-item d-flex align-items-center gap-1"
                    *ngFor="let entryName of entriesKeys; let i = index"
                >
                    <span class="entry-legend-dots">
                        <span
                            class="entry-legend-dot"
                            [style.background-color]="getEntryColor(i)"
                        ></span>
                        <span
                            class="entry-legend-dot entry-legend-dot-vs"
                            [style.background-color]="
                                getEntryVersusColor(i)
                            "
                        ></span>
                    </span>
                    <span class="entry-legend-label">{{ entryName }}</span>
                </div>
            </div>

            <div class="entry-scroll-zone flex-grow-1">
                <div
                    class="row entry-row mx-0"
                    *ngFor="let hourLabel of hourLabels; let i = index"
                    [style.height.px]="rowHeights[hourLabel]"
                >
                    <div class="col-3 center p-0 m-0 h-100">
                        <div class="labelXAxis" *ngIf="isDayFormat">
                            {{ hourLabel }}
                        </div>
                        <div
                            class="labelXAxis-compare d-flex flex-column"
                            *ngIf="!isDayFormat"
                        >
                            <span class="ref-text">{{ hourLabel }}</span>
                            <span class="comp-text">{{
                                getVersusLabel(i)
                            }}</span>
                        </div>
                    </div>

                    <div
                        class="col-7 center p-0 m-0 _first_chart_container_ h-100"
                    >
                        <div class="_second_chart_container_ w-100 h-100">
                            <canvas
                                [id]="'entry_chart' + i"
                                class="_chart_data_compare_x_axis_counting h-100 w-100"
                            ></canvas>
                        </div>
                    </div>

                    <div
                        class="col-2 entry-totals d-flex flex-column justify-content-center align-items-end p-0 h-100"
                    >
                        <div class="entry-total ref-text">
                            {{ getHourTotal(hourLabel, true) }}
                        </div>
                        <div class="entry-total comp-text">
                            {{ getHourTotal(hourLabel, false, i) }}
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <ng-template #emptyStateTemplate>
            <div class="col-12">
                <div
                    class="center indic bg-greyOpacity radius-secondary p-3 m-3"
                >
                    {{ 'closedData' | translate }}
                </div>
            </div>
        </ng-template>
    </ng-template>
</div>
